// eslint-disable-next-line import/prefer-default-export
export const FILTER_KEYS = {
  PAGE: 'page',
  PER_PAGE: 'limit',
  HAS_MORE: 'hasMore',
  CATEGORIES: 'category',
  MANUFACTURERS: 'manufacturer',
  STORAGE: 'storage',
  // QUANTITY: 'count',
  SORT_DIRECTION: 'orderBy',
  ITEMS: 'items',
  TAGS: 'tags',
  QUERY: 'query',
};

export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const TYPE = {
  SET: 'set',
  ITEM: 'item',
  COLOR: 'color',
};
